import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CancelInvoiceDTO  {
    _originalTypeClassName = "zERP.BO.CancelInvoiceDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CancelInvoiceDTO.translate = translateService;
}
this.CancellationDate = null;
this.CancelInvoiceDTOKey = null;
this._key = this.CancelInvoiceDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
CancellationDate:any;
CanceledBy:any;
RefundPaymentMethod:any;
CashAccount:any;
BankAccount:any;
private _CancelInvoiceDTOKey:any;
get CancelInvoiceDTOKey(): any {
    return this._CancelInvoiceDTOKey;
  }
set CancelInvoiceDTOKey(value: any) {
    this._CancelInvoiceDTOKey = value;
    this._key = value;
  }
static setCanceledBy = ($this, value) => {
var oldValue = $this.CanceledBy;
$this.CanceledBy = value;
if (value != null) {
}
}
static setRefundPaymentMethod = ($this, value) => {
var oldValue = $this.RefundPaymentMethod;
$this.RefundPaymentMethod = value;
if (value != null) {
}
}
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CancelInvoiceDTOKey == null || $this.CancelInvoiceDTOKey == 0;
            }


}